import { Redirect, Route } from "react-router-dom";
import { AuthContext } from "../components/context/AuthContext";
import { useContext } from "../ReactTS";
import Loading from "../components/common/Loading";
import * as React from "react";

const SecureRoute = ({ component: Component, ...rest }) => {
  const { isLoggedIn, currentEmail } = useContext(AuthContext);

  return (
    <Route
      {...rest}
      render={props => {
        if (currentEmail === undefined) {
          return <Loading />;
        }
        return isLoggedIn() ? <Component {...props} /> : <Redirect to={{ pathname: "/", state: { from: props.location } }} />;
      }}
    />
  );
};

export default SecureRoute;



// WEBPACK FOOTER //
// ./src/pages/PrivateRoute.tsx